import { render, staticRenderFns } from "./OnboardingMatchingFavoriteFlatsPage.vue?vue&type=template&id=3f1698bb&scoped=true&"
import script from "./OnboardingMatchingFavoriteFlatsPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingMatchingFavoriteFlatsPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingMatchingFavoriteFlatsPage.vue?vue&type=style&index=0&id=3f1698bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1698bb",
  null
  
)

export default component.exports